import { CookiesBannerStep } from 'cookies/types'

export const isInitialStep = (step: CookiesBannerStep): boolean =>
	step === CookiesBannerStep.initialStep

export const isFirstStep = (step: CookiesBannerStep): boolean =>
	step === CookiesBannerStep.firstStep

export const isSecondStep = (step: CookiesBannerStep): boolean =>
	step === CookiesBannerStep.secondStep
